import clsx from 'clsx'
import React, {useRef} from 'react'

import {Button, ButtonProps, IconButton} from '../button'
import {MinusIcon, PlusIcon} from '../icons'
import {BaseInputProps} from '../input'
import {PropsWithClasses} from '../theme/UNSTABLE_makeStyles'
import {Size} from '../types'
import {Typography} from '../typography'
import {ClassKey, useClasses} from './Counter.classes'

export type Props = Omit<BaseInputProps, 'size'> &
  PropsWithClasses<ClassKey> & {
    fullWidth?: boolean
    error?: boolean
    size?: Size
    onStepDown?: ButtonProps['onPress']
    onStepUp?: ButtonProps['onPress']
  }

const Counter: React.FC<Props> = props => {
  const {classes: classesProp, className, size = 'm', onStepDown, onStepUp, fullWidth, error, ...inputProps} = props
  const classes = useClasses(classesProp)
  const inputRef = useRef<HTMLInputElement>(null)
  const rootClassName = clsx(
    classes.root,
    classes[`size_${size}`],
    fullWidth && classes.fullWidth,
    error && classes.error,
  )

  // будем юзать нативные методы инпута, чтобы по максимуму переиспользовать то, что уже умеет браузер
  // включая пропсы step, min, max и тд
  const changeHandler = (direction: 'up' | 'down'): ButtonProps['onPress'] => {
    return () => {
      const inputElement = inputRef.current

      if (inputElement !== null) {
        direction === 'down' ? inputElement.stepDown() : inputElement.stepUp()
        inputElement.dispatchEvent(new Event('change', {bubbles: true}))
      }
    }
  }

  return (
    <div className={rootClassName} data-e2e="counter">
      <IconButton
        className={classes.button}
        disabled={inputProps.min !== undefined && inputProps.min == inputProps.value}
        onPress={onStepDown || changeHandler('down')}
        variant="ghost"
        size={size}
      >
        <MinusIcon />
      </IconButton>
      <Typography variant="body1">{inputProps.value}</Typography>
      <input ref={inputRef} className={clsx(classes.input, className)} type="number" readOnly {...inputProps} />
      <IconButton
        className={classes.button}
        disabled={inputProps.max !== undefined && inputProps.max == inputProps.value}
        onPress={onStepUp || changeHandler('up')}
        variant="ghost"
        size={size}
      >
        <PlusIcon />
      </IconButton>
    </div>
  )
}

export default Counter
